import styled from "styled-components";

import color from "../../constants/color";
import materialUI from "../../material-UI";

export const FormTag = styled(materialUI.ToggleButtonGroup)`
  width: 100%;
  flex-wrap: wrap;
`;

interface PropsColor {
  colorItem: string;
}

export const LabelTag = styled(materialUI.ToggleButton)<PropsColor>`
  height: 24px;
  min-width: 60px;
  background: #ffffff !important;
  border-radius: 16px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px !important;
  line-height: 16px !important;
  letter-spacing: -0.01em;
  text-transform: capitalize !important;
  padding: 0 8px !important;
  margin-right: 8px !important;
  margin-bottom: 6px !important;
  transition: all 0.2s;

  &.Mui-selected {
    color: ${color.White}!important;
    background: ${(props: PropsColor) => props.colorItem} !important;
  }
`;
